import type { ReactNode } from 'react';

export type SectionType = 'danger' | 'warn' | 'info';

const COLORS: Record<SectionType, string> = {
  danger: 'var(--danger)',
  warn: 'var(--warn)',
  info: 'var(--info)',
};

const BGS: Record<SectionType, string> = {
  danger: 'var(--danger-dim)',
  warn: 'var(--warn-dim)',
  info: 'var(--info-dim)',
};

interface Props {
  title: string;
  type: SectionType;
  children: ReactNode;
}

export function CompSection({ title, type, children }: Props) {
  return (
    <div
      style={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        overflow: 'hidden',
        marginBottom: 12,
      }}
    >
      <div
        style={{
          padding: '11px 15px',
          background: BGS[type],
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            fontFamily: 'Syne, sans-serif',
            fontWeight: 700,
            fontSize: 12,
            color: COLORS[type],
          }}
        >
          {title}
        </div>
      </div>
      <div style={{ padding: '0 2px' }}>{children}</div>
    </div>
  );
}

export function EmptyOk({ message }: { message: string }) {
  return <div style={{ color: 'var(--live)', padding: 10 }}>{`✓ ${message}`}</div>;
}
